import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { getInvestmentValueFormDefaults } from "web_myplann/Portfolio/Components/Redesign/Detail/Value/investmentValueFormDefaults";
import {
	getInvestmentValueFormSchema,
	type InvestmentValueFormInput,
	type InvestmentValueFormOutput,
} from "web_myplann/Portfolio/Components/Redesign/Detail/Value/investmentValueFormSchema";

type UseInvestmentValueFormArgs = {
	defaultInvested: number | null;
};

export const useInvestmentValueForm = ({
	defaultInvested,
}: UseInvestmentValueFormArgs) => {
	const { t } = useResource();

	return useForm<InvestmentValueFormInput, unknown, InvestmentValueFormOutput>({
		resolver: zodResolver(getInvestmentValueFormSchema(t)),
		defaultValues: getInvestmentValueFormDefaults(defaultInvested),
	});
};
